import request from '@/utils/request'

export default {
  // 查询价值观标签列表
  getValuesLabel(params) {
    return request({
      url: '/system/valuesLabel/list',
      method: 'GET',
      params
    })
  },
  // 新增修改价值观标签
  addOrEditValuesLabel(method, data) {
    return request({
      url: '/system/valuesLabel',
      method,
      data
    })
  },
  // 删除价值观标签
  delValuesLabel(id) {
    return request({
      url: `/system/valuesLabel/${id}`,
      method: 'DELETE'
    })
  },

  // 查询业务标签列表
  getBusinessLabelList(params) {
    return request({
      url: '/system/businessLabel/list',
      method: 'get',
      params
    })
  },
  // 新增修改业务标签
  addOrEditBusinessLabel(method, data) {
    return request({
      url: '/system/businessLabel',
      method,
      data
    })
  },
  // 删除业务标签
  delBusinessLabel(id) {
    return request({
      url: `/system/businessLabel/${id}`,
      method: 'DELETE'
    })
  },
  // 查询文章纠错列表
  getArticleErrorList(params) {
    return request({
      url: '/system/articleError/list',
      method: 'GET',
      params
    })
  },
  // 查询文章列表
  getArticleList(params) {
    return request({
      url: '/system/article/list',
      method: 'GET',
      params
    })
  },
  //新增或编辑文章
  addOrEditArticle(method, data) {
    return request({
      url: '/system/article',
      method,
      data
    })
  },
  // 删除文章
  delArticle(id) {
    return request({
      url: `/system/article/${id}`,
      method: 'delete'
    })
  },
  // 新增或修改文章章节
  addOrEditArticleChapter(method, data) {
    return request({
      url: '/system/articleChapter',
      method,
      data
    })
  },
  // 根据文章id获取文章章节列表
  getArticleChapterList(params) {
    return request({
      url: '/system/articleChapter/listById',
      method: 'GET',
      params
    })
  },
  // 删除文章章节
  delArticleChapter(id) {
    return request({
      url: `/system/articleChapter/${id}`,
      method: 'DELETE'
    })
  },
  // 获取文章章节详细信息
  getArticleChapterInfo(id) {
    return request({
      url: `/system/articleChapter/${id}`,
      method: 'GET'
    })
  },
  // 卡片语录列表
  getArticleCardListEdit(params) {
    return request({
      url: '/system/articleCard/listEdit',
      method: 'GET',
      params
    })
  },
  // 新增卡片语录
  addOrEditarticleCard(method, data) {
    return request({
      url: '/system/articleCard',
      method,
      data
    })
  },
  // 删除卡片语录
  delArticleCard(id) {
    return request({
      url: `/system/articleCard/${id}`,
      method: 'DELETE'
    })
  },
  // 查询文章评论列表
  getArticleCommentList(params) {
    return request({
      url: '/system/articleComment/listDetail',
      method: 'GET',
      params
    })
  },
  // 删除文章评论
  delArticleComment(id) {
    return request({
      url: `/system/articleComment/${id}`,
      method: 'DELETE'
    })
  },
  // 查询文章id查看语录列表
  articleChapterListCardById(articleId) {
    return request({
      url: '/system/articleChapter/listCardById',
      method: 'GET',
      params: { articleId }
    })
  },
  // 新增和修改图片卡片
  addOrEditArticleImageCard(method, data) {
    return request({
      url: '/system/articleImageCard',
      method,
      data
    })
  },
  // 查询图片卡片列表
  getArticleImageCardList(params) {
    return request({
      url: '/system/articleImageCard/list',
      method: 'GET',
      params
    })
  },
  // 删除图片卡片
  delArticleImageCard(id) {
    return request({
      url: `/system/articleImageCard/${id}`,
      method: 'DELETE'
    })
  },
  // 新增或编辑记念日卡片
  addOrEditArticleMemorialCard(method, data) {
    return request({
      url: '/system/articleMemorialCard',
      method,
      data
    })
  },
  // 获取记念日卡片列表
  getArticleMemorialCardList(params) {
    return request({
      url: '/system/articleMemorialCard/list',
      method: 'GET',
      params
    })
  },
  // 删除记念日卡片
  delArticleMemorialCard(id) {
    return request({
      url: `/system/articleMemorialCard/${id}`,
      method: 'DELETE'
    })
  },
  // 新增或编辑卡片抽奖
  addOrEditLottery(method, data) {
    return request({
      url: '/system/lottery',
      method,
      data
    })
  },
  // 获取卡片抽奖列表
  getLotteryList(params) {
    return request({
      url: '/system/lottery/list',
      method: 'get',
      params
    })
  },
  // 删除卡片抽奖列表
  delLotter(id) {
    return request({
      url: `/system/lottery/${id}`,
      method: 'DELETE'
    })
  },
  // 查询卡片领奖名单列表
  getAcceptList(params) {
    return request({
      url: '/system/accept/list',
      method: 'get',
      params
    })
  },
  //查询卡片抽奖奖品列表
  getCardPrizeList(params) {
    return request({
      url: '/system/prize/list',
      method: 'get',
      params
    })
  },
  // 新增编辑卡片抽奖奖品
  addOrEditCardPrize(method, data) {
    return request({
      url: '/system/prize',
      method,
      data
    })
  },
  //删除卡片抽奖奖品
  delCardPrize(id) {
    return request({
      url: `/system/prize/${id}`,
      method: 'DELETE'
    })
  },
  // 查询卡片分析列表
  getCardReadAnalysisList(params) {
    return request({
      url: '/card/readDuration/cardReadAnalysisList',
      method: 'get',
      params
    })
  },
  //查询用户阅读列表
  getReadDurationList(articleId, params) {
    return request({
      url: `/card/readDuration/list/${articleId}`,
      method: 'get',
      params
    })
  },
  // 导出卡片阅读时长列表
  exportReadDuration(params) {
    return request({
      url: '/system/accept/export',
      method: 'get',
      params
    })
  },
  // 导出路径
  exportReadDurationUrl(url) {
    return process.env.VUE_APP_BASE_API + '/common/download?fileName=' + url
  },
  //查询彩蛋条件列表
  getConditionList(params) {
    return request({
      url: '/system/condition/list',
      method: 'get',
      params
    })
  },
  // 新增彩蛋条件
  addOrEditCondition(method, data) {
    return request({
      url: '/system/condition',
      method,
      data
    })
  },
  //删除彩蛋条件
  delCondition(id) {
    return request({
      url: `/system/condition/${id}`,
      method: 'DELETE'
    })
  },
  //查询彩蛋奖品条件列表
  getArticlePrizeList(params) {
    return request({
      url: '/system/articlePrize/list',
      method: 'get',
      params
    })
  },
  // 新增彩蛋奖品条件
  addOrEditArticlePrize(method, data) {
    return request({
      url: '/system/articlePrize',
      method,
      data
    })
  },
  //删除彩蛋奖品条件
  delArticlePrize(id) {
    return request({
      url: `/system/articlePrize/${id}`,
      method: 'DELETE'
    })
  },
  //查询彩蛋奖品用户列表
  getUserPrizeList(params) {
    return request({
      url: '/system/articleUserPrize/list',
      method: 'get',
      params
    })
  },
  // 导出彩蛋奖品用户列表
  exportUserPrizeList(params) {
    return request({
      url: '/system/articleUserPrize/export',
      method: 'get',
      params
    })
  },

  // 导入文章
  importNew(data) {
    return request({
      url: '/system/articleCard/importNew',
      method: 'post',
      data
    })
  }
}
